import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const Fitting1State = Immutable.fromJS({
	alertStyle: null,
	alertMessage: null,
	orderId: '',
	allOrderIds: [],
	eventKey: 3,
	downloadUrl: '',
	orderDetail: {
		orderDetailId: null,
		customerGearName: '',
		bespokeHidden: ''
	},
	orderDetailValidation: {
		bespokeHidden: {
			validationState: null,
			helpBlock: null
		}
	},
	orderAppCheckList: [],
	orderAppCheck: {
		checkId: '',
		orderId: '',
		fittingName: '',
		startDate: null,
		endDate: null
	},
	orderAppCheckValidation: {
		fittingName: {
			validationState: null,
			helpBlock: null
		}
	},
	showAppCheckDiv: 'hidden'
});

const fitting1Reducer = handleActions({
	CHANGE_FITTING1_ORDERID: (state, { payload }) => {
		return state.merge({
			orderId: payload.orderId,
		})
	},
	CHANGE_FITTING1_EVENT_KEY: (state, { payload }) => {
		return state.merge({
			eventKey: payload
		})
	},
	FIND_ALL_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},
	EXPORT_FITTING_APP_DATA: (state, { payload }) => {
		return state.merge({
			downloadUrl: payload.data.downloadUrl,
			alertStyle: payload.alertStyle,
			alertMessage: payload.displayMessage,
		})
	},
	FIND_ORDER_DETAIL_BESPOKE: (state, { payload }) => {
		return state.merge({
			orderDetail: payload.data
		})
	},
	CHANGE_ORDER_DETAIL_BESPOKE_VALUE: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		return state.merge({
			orderDetail: orderDetail.set(payload.id, payload.value),
		})
	},
	EDIT_ORDER_DETAIL_BESPOKE: (state, { payload }) => {
		return state.merge({
			orderDetailValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CLEAR_FITTING1_DATA: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			downloadUrl: '',
			orderDetail: {
				orderDetailId: null,
				customerGearName: '',
				bespokeHidden: ''
			},
			orderDetailValidation: {
				bespokeHidden: {
					validationState: null,
					helpBlock: null
				}
			},
		})
	},
	CLEAR_FITTING1_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null
		})
	},
	BEFORE_UPLOAD_ORDERER_APP_DATA: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: '資料處理中，請稍後。'
		})
	},
	AFTER_UPLOAD_ORDERER_APP_DATA: (state, { payload }) => {
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FITTING_DEFAULT_VALIDATE_FAIL: (state, { payload }) => {
		return state.merge({
			alertStyle: 'danger',
			alertMessage: payload.displayMessage,
		})
	},
	DELETE_BY_DURATION: (state, { payload }) => {
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_ORDER_APPCHECK_LIST: (state, { payload }) => {
		return state.merge({
			orderAppCheckList: payload.data,
		})
	},
	FIND_ORDER_APPCHECK: (state, { payload }) => {
		return state.merge({
			orderAppCheck: payload.data,
		})
	},
	CHANGE_ORDER_APP_CHECK_VALUE: (state, { payload }) => {
		let orderAppCheck = state.get('orderAppCheck');
		return state.merge({
			orderAppCheck: orderAppCheck.set(payload.id, payload.value),
		})
	},
	EDIT_ORDER_APPCHECK: (state, { payload }) => {
		return state.merge({
			orderAppCheck: payload.data.bean,
			orderAppCheckValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	ADD_ORDER_APPCHECK: (state, { payload }) => {
		return state.merge({
			orderAppCheck: payload.data.bean,
			orderAppCheckValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CHANGE_SHOW_APPCHECK_DEV: (state, { payload }) => {
		return state.merge({
			showAppCheckDiv: payload,
		})
	},
	CLEAR_ORDER_APPCHECK_DATA: (state, { payload }) => {
		return state.merge({
			orderAppCheck: {
				checkId: '',
				orderId: payload,
				fittingName: '',
				startDate: null,
				endDate: null
			},
			orderAppCheckValidation: {
				fittingName: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
		})
	},
}, Fitting1State);

export default fitting1Reducer;


// WEBPACK FOOTER //
// ./src/reducers/fitting1Reducer.js